import React, { useState } from 'react';
// import './EditNumbers.css'; // Importing the CSS file
import NumberCard from '../About/NumberCards'; // Assuming NumberCard is in the same directory

const EditNumbers = () => {
  const [numberCards, setNumberCards] = useState([
    { number: 20, label: 'Team Members' },
    { number: 2024, label: 'Year Founded' },
    { number: 1000, label: 'Users' },
    { number: 69000000, label: 'Funding' }
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedCards = [...numberCards];
    updatedCards[index][field] = field === 'number' ? Number(value) : value;
    setNumberCards(updatedCards);
  };

  const moveCard = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= numberCards.length) return;
    const updatedCards = [...numberCards];
    const [movedCard] = updatedCards.splice(index, 1);
    updatedCards.splice(newIndex, 0, movedCard);
    setNumberCards(updatedCards);
  };

  return (
    <div className="edit-about edit-numbers-container">
      <h2>Edit Number Cards</h2>
      <div className="n-rwww">

        <NumberCard number={numberCards.number} label={numberCards.label} />
      </div>
          
      <div className="cards-container">
        {numberCards.map((card, index) => (
          <div key={index} className="edit-number-card">
            <div className="form-group">
              <label>Number</label>
              <input
                type="number"
                value={card.number}
                onChange={(e) => handleInputChange(index, 'number', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Label</label>
              <input
                type="text"
                value={card.label}
                onChange={(e) => handleInputChange(index, 'label', e.target.value)}
              />
            </div>
            <div className="button-group">
              <button onClick={() => moveCard(index, -1)} disabled={index === 0}>
                Move Left
              </button>
              <button onClick={() => moveCard(index, 1)} disabled={index === numberCards.length - 1}>
                Move Right
              </button>
            </div>
            <div className="button-group">
                 <button type="button" className="save-btn">
        Save Changes
      </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditNumbers;
